<template>
    <div>
        <div class="modal fade" id="trainingRoleUserStudentsModal" tabindex="-1" role="dialog"
             aria-labelledby="trainingRoleUserStudentsModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="trainingRoleUserStudentsModalLabel">{{trans('training.role_user.students_for_role')}} {{ roleName }} - {{ user.first_name }} {{ user.last_name}}</h5>
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <h4>{{trans('training.role_user.select_students')}}</h4>
                        <div class="row">
                            <div class="col-12 form-inline w-100 mb-3">
                                <div class="mr-4">
                                    <label class="justify-content-start" for="name">{{trans('training.role_user.filter')}}</label>
                                    <select @change="getTrainingAllStudents()" v-model="search.filterName"
                                            class="form-control" id="name" name="name">
                                        <option value="">{{trans('training.role_user.select_option')}}</option>
                                        <option value="asc">{{trans('training.role_user.ascending')}}</option>
                                        <option value="desc">{{trans('training.role_user.descending')}}</option>
                                    </select>
                                </div>
                                <div class="ml-auto">
                                    <label class="justify-content-start" for="search">{{trans('training.role_user.search_by')}}</label>
                                    <input class="form-control mr-sm-2" @input="searchUsersForCoach()" id="search"
                                           type="search" v-model="search.filterSearch" value="" :placeholder="trans('training.role_user.search')"
                                           aria-label="Search by name">
                                    <button @click="getTrainingAllStudents()" class="btn btn-outline-success my-2 my-sm-0"
                                            type="button">{{trans('training.role_user.search')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4" v-for="user in trainingStudents">
                                <div class="form-check">
                                    <input @change="checkStudent()" v-model="trainingRoleUserStudents"
                                           class="form-check-input" type="checkbox" :value="user.id"
                                           :id="'user-'+user.id">
                                    <label class="form-check-label" :for="'user-'+user.id">
                                        {{ user.first_name }} {{ user.last_name }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-12 text-center mt-3">
                                <div class='form-inline w-100 mb-3'>
                                    <select @change="getTrainingAllStudents()" v-model="search.entries"
                                            class="form-control" id="entries" name="entries">
                                        <option value="6">6</option>
                                        <option value="12">12</option>
                                        <option value="24">24</option>
                                        <option value="48">48</option>
                                    </select>
                                </div>
                                <button v-if="showLoadMore" type="button" @click='getTrainingAllStudents(search.page)'
                                        class="btn btn-primary">{{trans('training.role_user.load_more')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeModal">{{trans('training.role_user.close')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StudentGroupStudentsModal",
    props: {
        roleName: String,
        user: Object,
        training: Number,
    },
    data: function () {
        return {
            studentsSearch: "",
            trainingStudents: [],
            trainingRoleUserStudents: [],
            search: {
                filterName: '',
                filterSearch: '',
                page: 1,
                entries: 24,
            },
            showLoadMore: true,
        }
    },
    mounted() {
        this.getTrainingAllStudents()
        this.getTrainingRolesUserStudents()
        $('#trainingRoleUserStudentsModal').modal({backdrop: 'static', keyboard: true})
        $('#trainingRoleUserStudentsModal').modal('show');
    },
    methods: {
        closeModal: function () {
            this.$emit('modal-closed');
            $('#trainingRoleUserStudentsModal').modal('hide');
        },
        getTrainingRolesUserStudents() {
            if (this.training > 0 && this.user.tru_link_id > 0) {
                let $end = '/api/training-role-user-students/' + this.training + '/' + this.user.tru_link_id;
                let self = this;
                axios.get($end).then(function (response) {
                    response = response.data;
                    // console.log(response)
                    self.trainingRoleUserStudents = response;
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        getTrainingAllStudents(page = false) {
            if (this.training > 0) {
                let $end = '/api/training-all-students/' + this.training;
                let self = this;

                if (page) {
                    this.search.page = this.search.page + 1;
                } else {
                    this.search.page = 1;
                    self.showLoadMore = true;
                }

                axios.get($end, {params: this.search}).then(function (response) {
                    response = response.data;
                    // self.trainingStudents = [];
                    console.log(response)
                    if (self.search.page === response.last_page) {
                        self.showLoadMore = false;
                    }
                    if (page) {
                        self.trainingStudents = [...self.trainingStudents, ...response.data];
                    } else {
                        self.trainingStudents = response.data;
                    }
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        checkStudent() {
            let $end = '/api/training-role-user-students/' + this.training + '/' + this.user.tru_link_id;
            let self = this;

            axios.put($end, this.trainingRoleUserStudents).then(response => {
                self.loader = false;
            }).catch(err => {
                self.$data.loader = false;
            });
        },
        searchUsersForCoach() {
            if (this.trainingStudents.length < 1000 && (this.search.filterName.length >= 2 || this.search.filterName.length === 0)) {
                this.getTrainingAllStudents()
            }
        },
    }
}
</script>

<style scoped>
.fixed-height {
    max-height: 400px;
    overflow-y: auto;
}
</style>
